import React from "react";
import {
  FaRegCalendarCheck,
  FaTrophy,
  FaChartLine,
  FaBullseye,
} from "react-icons/fa";
import SEO from "./SEO";

// All download buttons on this page carry referrer=src%3Dwebsite (Task 2 spec).
const DOWNLOAD_URL =
  "https://play.google.com/store/apps/details?id=com.schooglink.curriculum.pathcharya&referrer=src%3Dwebsite";

// Self-hosted 9:16 explainer (H.264/AAC, ~2.9 MB, faststart) — light enough
// for slow networks; only the poster loads until the user taps play.
const VIDEO_SRC = "/videos/weekly_test.mp4";
const VIDEO_POSTER = "/videos/weekly_test_poster.jpg";
const OG_IMAGE = "https://schooglink.com/og/live-test.jpg";
// Promo card shown in the hero (same optimized 1200×670 asset as the OG image).
const HERO_IMAGE = "/og/live-test.jpg";

const FAQ_SECTIONS = [
  {
    title: "मूल बातें",
    items: [
      {
        q: "यह वीकली लाइव टेस्ट क्या है?",
        a: "हर शनिवार Pathyacharya पर एक लाइव चैप्टर टेस्ट होता है। तुम अपने बोर्ड और क्लास के हज़ारों स्टूडेंट्स के साथ एक ही टेस्ट देते हो और तुरंत अपनी रैंक देखते हो।",
      },
      {
        q: "क्या यह फ्री है?",
        a: "हाँ। टेस्ट देना, अपना स्कोर, रैंक और रेडीनेस स्कोर देखना — सब बिल्कुल फ्री है।",
      },
      {
        q: "किन क्लास और बोर्ड के लिए है?",
        a: "क्लास 9, 10, 11 और 12 — बिहार (BSEB), यूपी (UPMSP), झारखंड (JAC) और एमपी (MPBSE) बोर्ड के लिए। टेस्ट तुम्हारे अपने बोर्ड और क्लास के सिलेबस से ही आते हैं।",
      },
      {
        q: "टेस्ट कब होता है?",
        a: "हर शनिवार शाम 7 बजे टेस्ट खुलता है और रविवार रात 9 बजे बंद होता है। इस बीच कभी भी, एक बार टेस्ट दे सकते हो।",
      },
    ],
  },
  {
    title: "टेस्ट कैसे दें",
    items: [
      {
        q: "टेस्ट कैसे जॉइन करूँ?",
        a: "ऐप खोलो, होम स्क्रीन पर “इस हफ़्ते का लाइव टेस्ट” पर टैप करो, और शुरू कर दो।",
      },
      {
        q: "क्या मुझे ठीक शनिवार 7 बजे ऑनलाइन रहना ज़रूरी है?",
        a: "नहीं। टेस्ट रविवार रात 9 बजे तक खुला रहता है — अपनी सुविधा से कभी भी दे सकते हो। बस विंडो बंद होने से पहले पूरा कर लेना।",
      },
      {
        q: "टेस्ट में कितने सवाल होते हैं?",
        a: "करीब 30 सवाल, जो लगभग 30–40 मिनट में पूरे हो जाते हैं।",
      },
      {
        q: "नेट स्लो है या डेटा कम है, तब भी चलेगा?",
        a: "हाँ। टेस्ट हल्का है और तुम्हारे जवाब फ़ोन में सेव होते रहते हैं — सबमिट करते समय ही सिंक होते हैं।",
      },
      {
        q: "टेस्ट के बीच नेट कट गया तो?",
        a: "चिंता मत करो — तुम्हारे जवाब सेव रहते हैं। नेट आने पर वहीं से जारी रख सकते हो।",
      },
    ],
  },
  {
    title: "रिज़ल्ट और रैंक",
    items: [
      {
        q: "रैंक कैसे तय होती है?",
        a: "तुम्हारी रैंक तुम्हारे अपने बोर्ड और क्लास के स्टूडेंट्स के बीच होती है — यानी बराबरी का मुक़ाबला। सिर्फ़ लाइव विंडो में दिए गए टेस्ट रैंक में गिने जाते हैं।",
      },
      {
        q: "रिज़ल्ट कब मिलता है?",
        a: "रविवार रात 9 बजे टेस्ट बंद होते ही, करीब 9:15 बजे तुम्हारा स्कोर और रैंक आ जाती है।",
      },
      {
        q: "बोर्ड रेडीनेस स्कोर क्या है?",
        a: "यह 0 से 100 तक का एक नंबर है जो बताता है कि बोर्ड के लिए तुम्हारी तैयारी कितनी हुई। बोर्ड में बार-बार पूछे जाने वाले चैप्टर्स इसमें ज़्यादा मायने रखते हैं। जैसे-जैसे चैप्टर पक्के होते हैं, स्कोर बढ़ता है।",
      },
      {
        q: "क्या मैं टेस्ट दोबारा दे सकता हूँ?",
        a: "लाइव विंडो में रैंक के लिए एक बार। उसके बाद वही टेस्ट प्रैक्टिस में आ जाता है — जितनी बार चाहो प्रैक्टिस करो। इससे रेडीनेस स्कोर सुधरता है, पर रैंक नहीं बदलती।",
      },
    ],
  },
  {
    title: "देर से जुड़े हो?",
    items: [
      {
        q: "मैंने ऐप बाद में डाउनलोड किया — क्या मैं पीछे रह जाऊँगा?",
        a: "बिल्कुल नहीं। पिछले हफ़्तों के सारे टेस्ट प्रैक्टिस में मौजूद हैं — उन्हें देकर अपनी तैयारी और रेडीनेस स्कोर पूरा कर सकते हो। रेडीनेस स्कोर इस बात पर है कि तुम क्या जानते हो, कब जुड़े इस पर नहीं।",
      },
      {
        q: "लीग और रैंक में देर से जुड़ने पर नुक़सान होगा?",
        a: "नहीं — लीग हर हफ़्ते नई शुरू होती है और तुम अपने जैसे लेवल वालों से मुक़ाबला करते हो। मेहनत करोगे तो पहले से जुड़े स्टूडेंट से भी आगे निकल सकते हो।",
      },
    ],
  },
  {
    title: "फ्री और प्रीमियम",
    items: [
      {
        q: "क्या सब कुछ फ्री है?",
        a: "टेस्ट, स्कोर, रैंक, रेडीनेस स्कोर, और कौन-से सवाल सही/ग़लत हुए — सब फ्री। हर ग़लत सवाल का पूरा स्टेप-बाय-स्टेप हल और AI समझाइश प्रीमियम में है।",
      },
      {
        q: "सलूशन देखने के लिए पैसे क्यों?",
        a: "टेस्ट और रिज़ल्ट हमेशा फ्री रहेंगे। हर सवाल का विस्तार से हल, “कहाँ ग़लती हुई” की AI समझाइश, और कमज़ोर चैप्टर्स की एक्स्ट्रा प्रैक्टिस — ये प्रीमियम का हिस्सा हैं। हर हफ़्ते 1 सलूशन फ्री में अनलॉक कर के क्वालिटी ख़ुद देख सकते हो।",
      },
    ],
  },
  {
    title: "स्ट्रीक, लीग और टॉपर",
    items: [
      {
        q: "स्ट्रीक क्या है? एक हफ़्ता मिस कर दूँ तो?",
        a: "हर हफ़्ते टेस्ट देने पर तुम्हारी स्ट्रीक बढ़ती है। एक हफ़्ता मिस हो जाए तो “फ्रीज़” इस्तेमाल करके स्ट्रीक बचा सकते हो।",
      },
      {
        q: "लीग कैसे काम करती है?",
        a: "तुम अपने जैसे लेवल के स्टूडेंट्स के ग्रुप में होते हो। हर हफ़्ते अच्छा करने पर ऊपर की लीग में चढ़ते हो।",
      },
      {
        q: "टॉपर लिस्ट में कैसे आऊँ?",
        a: "हर हफ़्ते अपने बोर्ड और क्लास में टॉप स्कोर करने वाले स्टूडेंट टॉपर लिस्ट में आते हैं।",
      },
    ],
  },
  {
    title: "प्राइवेसी और भरोसा",
    items: [
      {
        q: "क्या मेरा नाम सबको दिखेगा?",
        a: "सिर्फ़ तभी जब तुम इजाज़त दो। डिफ़ॉल्ट में सिर्फ़ पहला नाम और शहर दिखता है — पूरी जानकारी कभी नहीं।",
      },
      {
        q: "क्या ये टेस्ट सच में बोर्ड एग्ज़ाम में मदद करेंगे?",
        a: "हाँ। टेस्ट तुम्हारे बोर्ड के पिछले सालों के पैटर्न पर बने हैं, और रेडीनेस स्कोर बताता है किन चैप्टर्स पर अभी मेहनत बाकी है — ताकि फरवरी तक तुम पूरी तरह तैयार हो।",
      },
    ],
  },
];

function DownloadButton({ children, className = "" }) {
  return (
    <a
      href={DOWNLOAD_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-block rounded-full bg-blue-600 px-8 py-4 text-lg font-bold text-white shadow-lg active:scale-[0.98] transition-transform ${className}`}
    >
      {children}
    </a>
  );
}

// Self-hosted vertical (9:16) explainer. preload="none" + poster means the
// browser fetches only the poster image until the user taps play — no heavy
// media download on page load. Width is capped so the tall video isn't huge.
function LazyVideo() {
  return (
    <div className="mx-auto w-full max-w-[320px] overflow-hidden rounded-2xl bg-black aspect-[9/16]">
      <video
        className="h-full w-full"
        src={VIDEO_SRC}
        poster={VIDEO_POSTER}
        controls
        preload="none"
        playsInline
        aria-label="Pathyacharya लाइव टेस्ट — explainer video"
      />
    </div>
  );
}

const STEPS = [
  {
    icon: FaRegCalendarCheck,
    text: "हर हफ़्ते chapter-wise लाइव टेस्ट",
  },
  {
    icon: FaTrophy,
    text: "टेस्ट के तुरंत बाद पूरे राज्य में अपनी रैंक",
  },
  {
    icon: FaChartLine,
    text: "बोर्ड परीक्षा के लिए readiness score",
  },
  {
    icon: FaBullseye,
    text: "कमज़ोर chapters साफ़-साफ़ पता चलें",
  },
];

const LiveTest = () => {
  return (
    <main className="font-hindi text-gray-900">
      <SEO
        title="फ्री लाइव टेस्ट हर शनिवार | Pathyacharya"
        description="क्लास 9–12 · बिहार, यूपी, झारखंड, एमपी बोर्ड · पूरे राज्य में अपनी रैंक देखो। बिल्कुल फ्री।"
        url="https://schooglink.com/live-test"
        image={OG_IMAGE}
      />

      {/* Hero */}
      <section className="bg-gradient-to-b from-blue-50 to-white px-4 pt-24 pb-12 text-center">
        <div className="mx-auto max-w-2xl">
          <span className="inline-block rounded-full bg-yellow-100 border border-yellow-400 px-3 py-1 text-xs font-bold text-yellow-800">
            हर शनिवार · बिल्कुल फ्री
          </span>
          <h1 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold leading-snug">
            हर शनिवार फ्री लाइव टेस्ट
          </h1>
          <p className="mt-4 text-base sm:text-lg text-gray-700">
            क्लास 9–12 · बिहार, यूपी, झारखंड, एमपी बोर्ड · पूरे राज्य में अपनी रैंक
          </p>
          <img
            src={HERO_IMAGE}
            alt="महा लाइव टेस्ट — क्लास 9–12 · बिहार, यूपी, झारखंड, एमपी बोर्ड · हर शनिवार शाम 7 बजे · बिल्कुल फ्री"
            width="1200"
            height="670"
            fetchpriority="high"
            className="mx-auto mt-8 w-full max-w-xl rounded-2xl border border-gray-200 shadow-lg"
          />
          <div className="mt-8">
            <DownloadButton>अभी डाउनलोड करो</DownloadButton>
          </div>
        </div>
      </section>

      {/* Explainer video */}
      <section className="px-4 py-12">
        <div className="mx-auto max-w-2xl">
          <h2 className="mb-6 text-center text-2xl sm:text-3xl font-bold">
            कैसे काम करता है — देखिए
          </h2>
          <LazyVideo />
        </div>
      </section>

      {/* How it works */}
      <section className="bg-gray-50 px-4 py-12">
        <div className="mx-auto max-w-2xl">
          <h2 className="mb-8 text-center text-2xl sm:text-3xl font-bold">
            कैसे काम करता है
          </h2>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {STEPS.map(({ icon: Icon, text }) => (
              <li
                key={text}
                className="flex items-center gap-4 rounded-2xl border border-gray-200 bg-white p-5"
              >
                <Icon className="shrink-0 text-2xl text-blue-600" aria-hidden />
                <span className="text-base font-medium text-gray-800">
                  {text}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* FAQ — collapsible accordion (native <details>, zero extra JS) */}
      <section aria-label="अक्सर पूछे जाने वाले सवाल" className="px-4 py-12">
        <div className="mx-auto max-w-2xl">
          <h2 className="mb-8 text-center text-2xl sm:text-3xl font-bold">
            अक्सर पूछे जाने वाले सवाल
          </h2>
          <div className="space-y-8">
            {FAQ_SECTIONS.map((section) => (
              <div key={section.title}>
                <h3 className="mb-3 text-lg font-bold text-blue-700">
                  {section.title}
                </h3>
                <div className="divide-y divide-gray-200 overflow-hidden rounded-2xl border border-gray-200 bg-white">
                  {section.items.map((f) => (
                    <details key={f.q} className="group">
                      <summary className="flex cursor-pointer list-none items-center justify-between px-5 py-4 font-semibold marker:hidden">
                        <span>{f.q}</span>
                        <span
                          aria-hidden
                          className="ml-4 select-none text-xl text-blue-600 transition-transform group-open:rotate-45"
                        >
                          +
                        </span>
                      </summary>
                      <div className="px-5 pb-5 leading-relaxed text-gray-700">
                        {f.a}
                      </div>
                    </details>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-blue-600 px-4 py-14 text-center">
        <div className="mx-auto max-w-2xl">
          <h2 className="text-2xl sm:text-3xl font-bold text-white">
            इस शनिवार के टेस्ट के लिए तैयार हो जाओ
          </h2>
          <p className="mt-3 text-blue-100">
            अभी ऐप डाउनलोड करो और पूरे राज्य में अपनी रैंक देखो।
          </p>
          <div className="mt-8">
            <DownloadButton className="bg-white !text-blue-700">
              अभी डाउनलोड करो
            </DownloadButton>
          </div>
        </div>
      </section>
    </main>
  );
};

export default LiveTest;
